import { backend } from "../services";
import { actions } from "./reducer";
import store from "./store";

export function currentUserGroupFilter () {
    const state = store.getState(),
    rights = state.rights,
    group = rights.group_ids[0];
    return { group_id: group || undefined}
}

export async function setupAvailableGroups () {
    const state = store.getState(),
    rights = state.rights;
    if (!rights) return [];
    const allGroups = await backend.getAllGroups();
    const availableGroups = allGroups.groups.filter((item) => {
        return (
          rights.rang < 3 ||
          rights.group_ids.includes(item.id)
        );
    });
    store.dispatch(actions.setGroupsToSelect(availableGroups)) 
}